import { render, staticRenderFns } from "./ProcessHistory.vue?vue&type=template&id=4674059e&scoped=true"
import script from "./ProcessHistory.vue?vue&type=script&lang=js"
export * from "./ProcessHistory.vue?vue&type=script&lang=js"
import style0 from "./ProcessHistory.vue?vue&type=style&index=0&id=4674059e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674059e",
  null
  
)

export default component.exports